// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"AccordionList_desktopImg__ong7h","mobileImg":"AccordionList_mobileImg__lUTla","el":"AccordionList_el__UwHyr","elNoPadding":"AccordionList_elNoPadding__6fAGT"};